// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "48189f6c44e04b1f9d7c1d187a7e5cecbeb7a6ab/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};